import React, { useEffect, useState } from 'react';
import {API} from 'aws-amplify';
import ProductCard from '../components/ProductCard';
import ProductDetailsModal from '../components/ProductDetailsModal';
import { useCart } from '../components/CartContext';
import mockProducts from '../mockProducts.json';

function Women() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await API.get('apiNtrepid', '/items', {
          queryStringParameters: { type: 'Women' }
        });

        console.log('Fetched products response:', response);

        const filteredProducts = (response.items || response).filter(
          item => item.type === 'Women' && item.sold !== true
        );

        setProducts(filteredProducts);
      } catch (error) {
        console.error('Error fetching products:', error);

        const fallback = mockProducts.filter(
          item => item.type === 'Women' && item.sold !== true
        );

        setProducts(fallback);
      }
    };

    fetchProducts();
  }, []);

  const handleViewDetails = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  return (
    <div className="container px-4 px-lg-5 mt-5 flex-grow-1">
      <div className="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onViewDetails={handleViewDetails}
          />
        ))}
      </div>
      <ProductDetailsModal
        show={showModal}
        handleClose={handleCloseModal}
        product={selectedProduct}
        addToCart={addToCart}
      />
    </div>
  );
}

export default Women;
